module.exports = __webpack_public_path__ + "img/camp_shirt_gk7.1b2115a6.svg";